import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

import { PatchQuestion } from 'react-bootstrap-icons';

import { sendOpenSpillCountExplainModal } from './GoogleAnalytics.js';

const SpillCountExplainModal = function() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = function() {
    sendOpenSpillCountExplainModal();
    setShow(true);
  };

  return (
    <>
      <Button key="spillCountOpenModalBtn" variant="dark" size="sm" onClick={handleShow} style={{marginTop: "3px", marginBottom: "3px"}}>
        <PatchQuestion /> How are spills calculated?
      </Button>
      <Modal key="spillCountModal" show={show} onHide={handleClose} contentClassName="bg-dark text-white" centered>
        <Modal.Header closeButton>
          <Modal.Title>How are spills calculated?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <b>Spill counts are calculated using the 12/24 method. This method was defined by <i>OFWAT</i>.</b><br />
          A calculation is performed like this:
          <ul>
          	<li>Start counting when discharge first occurs</li>
          	<li>Any discharges occuring within the first 12 hours from this spill, even if it stops and restarts, are counted as one spill.</li>
          	<li>If discharge(s) is/are still occuring within the next 24 hours, after this first 12 hours, that is counted as a subsequent spill, even if it stops and restarts.</li>
          	<li>For each 24 hour period, this is repeated and is classed as another spill.</li>
          	<li>A spill is not over until 24 hours has elapsed since the previous discharge event</li>
          </ul>
       	<b>Worked Example</b><br />
       	A set of discharge events lasting 61 hours. This is:
       	<ul>
       		<li>1st spill
       			<ul>
       				<li>The initial 12 hours, covering 0-12h.</li>
       				<li>The discharge was continous</li>
       			</ul>
       		</li>
       		<li>2nd spill
       			<ul>
       				<li>The subsequent 24 hours, covering 12-36h</li>
       				<li>The discharge was continous</li>
       			</ul>
       		</li>
       		<li>3rd spill
       			<ul>
       				<li>The subsequent 24 hours, covering 36-60h</li>
       				<li>The discharge stopped and started multiple times, still classed as 1 spill.</li>
       			</ul>
       		</li>
       		<li>4th spill
       			<ul>
       				<li>The subsequent 24 hours, covering 60-84h</li>
       				<li>The spill stopped at hour 61</li>
       			</ul>
       		</li>
       	</ul>
        As no subsequent discharges for 24hours from hour 61, the event is over.<br />Totalling <b>4</b> spills.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SpillCountExplainModal;
